import React from "react";
import { Mail, MapPin, Clock } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { ContactForm } from "../components/ContactForm";
import { Reveal } from "../components/Reveal";
import { useLang } from "../i18n/LanguageContext";

export default function Contact() {
  const { t } = useLang();
  const info = [
    { icon: Mail, label: t({ en: "Email", no: "E-post" }), value: "hello@jorviko.no" },
    { icon: MapPin, label: t({ en: "Location", no: "Lokasjon" }), value: t({ en: "Oslo, Norway", no: "Oslo, Norge" }) },
    { icon: Clock, label: t({ en: "Response time", no: "Responstid" }), value: t({ en: "Within 24 hours", no: "Innen 24 timer" }) },
  ];
  return (
    <>
      <PageHero
        overline={t({ en: "Contact", no: "Kontakt" })}
        title={t({ en: "Let's build intelligent software together.", no: "La oss bygge intelligent programvare sammen." })}
        subtitle={t({
          en: "Book a discovery call. We'll map the fastest, most secure path from your challenge to value.",
          no: "Book en oppdagelsessamtale. Vi kartlegger den raskeste, sikreste veien fra utfordring til verdi.",
        })}
      />
      <section className="relative py-20 md:py-28">
        <div className="mx-auto max-w-7xl px-6 md:px-12 grid gap-12 lg:grid-cols-[1fr_1.4fr]">
          <Reveal>
            <div className="space-y-8">
              {info.map((item, i) => (
                <div key={i} className="flex items-start gap-4" data-testid={`contact-info-${i}`}>
                  <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-white/10 bg-white/[0.03] text-[#60A5FA]">
                    <item.icon className="h-5 w-5" />
                  </div>
                  <div>
                    <p className="font-mono text-[11px] tracking-widest uppercase text-white/40">{item.label}</p>
                    <p className="mt-1 text-lg text-white">{item.value}</p>
                  </div>
                </div>
              ))}
              <div className="rounded-2xl border border-white/[0.07] bg-[#0A0E17] p-6">
                <p className="text-white/55 leading-relaxed">
                  {t({
                    en: "Serving enterprises and government organisations across Norway — expanding into Europe.",
                    no: "Vi betjener virksomheter og offentlige organisasjoner i hele Norge — med ekspansjon i Europa.",
                  })}
                </p>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <ContactForm />
          </Reveal>
        </div>
      </section>
    </>
  );
}
